import React,
{
    useEffect,
    useState
}
from 'react';
import
{
    normalizePath
}
from './Router';
import
{
    createPreloadedAudio
}
from './audioPreload';

const FULL_MOON_CLUB_AUDIO_CONFIG_URL = '/fullMoonClubAudio.json';

function readCachedConfig()
{
    try
    {
        return window.__aw24FullMoonClubAudioConfig || null;
    }
    catch (e)
    {
        return null;
    }
}

function cacheConfig(config)
{
    try
    {
        window.__aw24FullMoonClubAudioConfig = config;
    }
    catch (e)
    {}
}

function buildDispatchPayload(config)
{
    const safeConfig = config && typeof config === 'object' ? config :
    {};

    return {
        ...safeConfig,
        name: safeConfig.name || 'Full Moon Club',
        routePath: '/FullMoonClub',
    };
}

function preloadFullMoonClubAudio(config)
{
    const safeConfig = config && typeof config === 'object' ? config :
    {};

    try
    {
        if (!window.__aw24FullMoonClubPreloadedAudio) window.__aw24FullMoonClubPreloadedAudio = {};

        [safeConfig.music, safeConfig.intro]
        .filter(Boolean)
            .forEach((src) =>
            {
                try
                {
                    if (window.__aw24FullMoonClubPreloadedAudio[src]) return;
                    const audio = createPreloadedAudio(src,
                    {
                        baseVolume: 1,
                        loop: false,
                        applyMaster: false,
                    });
                    if (!audio) return;
                    window.__aw24FullMoonClubPreloadedAudio[src] = audio;
                }
                catch (e)
                {}
            });
    }
    catch (e)
    {}
}

export default function FullMoonClub()
{
    const [audioConfig, setAudioConfig] = useState(() => readCachedConfig());

    useEffect(() =>
    {
        let cancelled = false;

        if (audioConfig) return undefined;

        const loadConfig = async () =>
        {
            try
            {
                const response = await fetch(FULL_MOON_CLUB_AUDIO_CONFIG_URL,
                {
                    cache: 'no-store'
                });
                if (!response.ok) throw new Error(`Failed to load ${FULL_MOON_CLUB_AUDIO_CONFIG_URL}`);

                const data = await response.json();
                cacheConfig(data);
                if (!cancelled)
                {
                    setAudioConfig(data);
                }
            }
            catch (err)
            {
                if (!cancelled) setAudioConfig(null);
            }
        };

        loadConfig();

        return () =>
        {
            cancelled = true;
        };
    }, [audioConfig]);

    useEffect(() =>
    {
        if (!audioConfig) return;
        if (normalizePath(window.location.pathname || '/') !== '/FullMoonClub') return;

        try
        {
            preloadFullMoonClubAudio(audioConfig);
        }
        catch (e)
        {}

        try
        {
            window.dispatchEvent(new CustomEvent('main-class-selected',
            {
                detail: buildDispatchPayload(audioConfig)
            }));
        }
        catch (e)
        {}
    }, [audioConfig]);

    return ( <div style = {
            {
                position: 'fixed',
                inset: 0,
                zIndex: 2200,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 24,
                textAlign: 'center',
                color: '#fff',
            }
        } >
        <div style = {
            {
                maxWidth: 720
            }
        } >
        <h1 style = {
            {
                margin: 0,
                fontSize: '1.6rem',
                fontFamily: `'Valve Pulp', 'Segoe UI', sans-serif`
            }
        } >
        Something spooky will be here soon. </h1> </div> </div>
    );
}
